import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import KitchenSetup from "./KitchenSetup";
import { onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { auth } from "./firebase";

import DashboardCucina from "./DashboardCucina";

// ─── WRAPPER ─────────────────────────────────────────
function DashboardCucinaWrapper() {
  const locale = localStorage.getItem("kitchen_locale");

  if (!locale) {
    return <KitchenSetup onConfigured={() => window.location.reload()} />;
  }

  return <DashboardCucina localeTag={locale} />;
}

// ─── SCHERMATA STANDBY ───────────────────────────────
function KitchenStandby({ onWake }) {
  const [ora, setOra] = useState(new Date());

  useEffect(() => {
    const i = setInterval(() => setOra(new Date()), 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <div
      onClick={onWake}
      onTouchStart={onWake}
      style={{
        height: "100vh",
        background: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        userSelect: "none",
        pointerEvents: "auto"
      }}
    >
      <div style={{ fontSize: "4rem", fontWeight: "600" }}>
        {ora.toLocaleTimeString("it-IT")}
      </div>

      <div style={{ marginTop: "1rem", opacity: 0.6 }}>
        👨‍🍳 Cucina in standby
      </div>

      <div style={{ marginTop: "2rem", fontSize: "0.9rem", opacity: 0.4 }}>
        Tocca per riattivare
      </div>
    </div>
  );
}

// ─── APP PRINCIPALE ─────────────────────────────────
function AppKitchen() {
  const [authReady, setAuthReady] = useState(false);

  // 🔥 STATO STANDBY PERSISTENTE
  const [isStandby, setIsStandby] = useState(() => {
    return localStorage.getItem("kitchen_standby") === "1";
  });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      try {
        if (!u) {
          await signInAnonymously(auth);
        }
      } catch (e) {
        console.error("❌ Errore auth anonima:", e);
      } finally {
        setAuthReady(true);
      }
    });

    return () => unsub();
  }, []);

  // 🔥 WAKE
  const wakeUp = () => {
    localStorage.setItem("kitchen_standby", "0");
    setIsStandby(false);
  };

  // 🔥 METTI IN STANDBY (lo useremo dopo)
  const goStandby = () => {
    localStorage.setItem("kitchen_standby", "1");
    setIsStandby(true);
  };

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      console.log("📲 PWA install disponibile cucina");
      window.__KITCHEN_INSTALL_PROMPT = e;
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const justConfigured = localStorage.getItem("kitchen_just_configured");

  if (!authReady) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0f0f12",
          color: "#fff",
          fontSize: "1.2rem"
        }}
      >
        👨‍🍳 Avvio cucina...
      </div>
    );
  }

  // 🔥 SE STANDBY → BLOCCA TUTTO QUI
  if (isStandby) {
    return <KitchenStandby onWake={wakeUp} />;
  }

  if (justConfigured === "true") {
    return (
      <PostConfigScreen
        onContinue={() => {
          localStorage.removeItem("kitchen_just_configured");
window.location.href = "/?source=pwa";
        }}
      />
    );
  }

  return (
    <Routes>
      <Route path="*" element={<DashboardCucinaWrapper goStandby={goStandby} />} />
    </Routes>
  );
}

function PostConfigScreen({ onContinue }) {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0f0f12",
      color: "#fff",
      textAlign: "center",
      padding: "2rem"
    }}>
      <div>
        <h2>👨‍🍳 Cucina configurata</h2>
        <p style={{ opacity: 0.7 }}>
          Apri la cucina e attiva le notifiche per iniziare
        </p>


        {(() => {
          const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
          const justConfigured = localStorage.getItem("kitchen_just_configured");
          return (
            !isIOS && justConfigured === "true" && window.__KITCHEN_INSTALL_PROMPT && (
              <button
                onClick={async () => {
                  window.__KITCHEN_INSTALL_PROMPT.prompt();
                  await window.__KITCHEN_INSTALL_PROMPT.userChoice;
                  window.__KITCHEN_INSTALL_PROMPT = null;
                }}
                style={{
                  marginTop: "1rem",
                  padding: "12px 20px",
                  borderRadius: "10px",
                  border: "none",
                  background: "#0a84ff",
                  color: "#fff"
                }}
              >
                📲 Installa app
              </button>
            )
          );
        })()}

        <div>
          <button
            onClick={onContinue}
            style={{
              marginTop: "1.5rem",
              padding: "0.9rem 1.4rem",
              borderRadius: "14px",
              border: "none",
              background: "linear-gradient(135deg, #0a84ff, #2563eb)",
              color: "#fff",
              fontWeight: 600,
              fontSize: "0.95rem",
              boxShadow: "0 6px 20px rgba(0,0,0,0.35)",
              cursor: "pointer"
            }}
          >
            Continua
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppKitchen;